/* eslint-disable no-unused-vars */
import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import AttributeReport from '../../../features/reports/attribute/AttributeReport'

export const types = {
  ADD_RANKING_REPORT_KEYWORDS: 'keyword-ranking-report/ADD_RANKING_REPORT_KEYWORDS'
}
const state = {
  keywords: []
}

const mutations = {
  [types.ADD_RANKING_REPORT_KEYWORDS]: function (state, data) {
    state.keywords = data
  }
}

const actions = {
  loadKeywordsData: async function ({ commit }, { clientId, filters }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    filters.msv = msv[clientId] || 1
    const params = convertAdvancedOptionsToURLParams(filters)
    const response = await httpService.get(`/keyword-ranking-report/${clientId}`, { params })
    if (!response || !response.data) {
      return
    }
    commit(types.ADD_RANKING_REPORT_KEYWORDS, response.data.keywords)
    return response.data
  },
  resetKeywordsList: async function ({ commit }) {
    commit(types.ADD_RANKING_REPORT_KEYWORDS, [])
  }
}

/**
 * Store manage data for Reports/Attribute Reports {@link AttributeReport}
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
